import { NextPage } from 'next';
import { useTranslation } from 'react-i18next';

import Layout from 'modules/layout';
import GuidelinesContent from 'modules/static-pages/pages/guidelines';
import { getBasicStaticProps } from 'utils/page';

// TODO: Move to i18n
const seoData: Record<string, Record<string, any>> = {
  en: {
    seo: {
      description: 'Community Guidelines to use Zehitomo. For both professionals and users. ',
      ogDescription: 'Community Guidelines to use Zehitomo. For both professionals and users. ',
      ogTitle: 'Guidelines | Zehitomo',
    },
    title: 'Guidelines',
  },
  ja: {
    seo: {
      description: 'ゼヒトモをご利用する上でのガイドラインを掲載しています。',
      keywords: 'ガイドライン',
      ogDescription: 'ゼヒトモをご利用する上でのガイドラインを掲載しています。',
      ogTitle: 'ご利用ガイドライン | ゼヒトモ',
    },
    title: 'ご利用ガイドライン',
  },
};

const GuidelinesPage: NextPage = () => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <Layout {...seoData[language]} language={language}>
      <GuidelinesContent />
    </Layout>
  );
};

export const getStaticProps = getBasicStaticProps(['staticPages']);

export default GuidelinesPage;
